//Style
import './FaqContent.scss';
export class FaqController {
    static $inject = ['LoadingService', 'ngToast', 'FaqService', 'application', '$filter', '$timeout', '$interval', '$rootScope', '$scope', '$translate'];
    constructor(LoadingService, ngToast, FaqService, application, $filter, $timeout, $interval, $rootScope, $scope, $translate) {
        'ngInject';
        this.$onInit = () => { };
        this._loadingService = LoadingService;
        this._ngToast = ngToast;
        this._faqService = FaqService;
        this._application = application;
        this._$filter = $filter;
        this._$timeout = $timeout;
        this._$interval = $interval;
        this._$rootScope = $rootScope;
        this._$scope = $scope;
        this._$translate = $translate;
        //Pagination
        this.faqPerPage = 10;
        this.perPageAux = 0;
        this.init();
    }
    set canTrain(value) {
        this._canTrain =
            value == 'true' &&
                this.classifier != undefined &&
                this.contextStatus != 1;
    }
    get canTrain() {
        return this._canTrain;
    }
    get faqSets() {
        return this._faqSets;
    }
    set faqSets(faqSets) {
        this._faqSets = faqSets || {};
    }
    throwInterval() {
        if (this.currentWatcher == undefined) {
            const interval = this._$interval(async () => {
                await this.getCurrentContext();
                if (this.contextStatus != 1) {
                    this.perPageAux = 0;
                    await this._loadIntentions();
                    this.stopChecking(interval);
                }
            }, 30000, 0, true);
            this.currentWatcher = interval;
        }
    }
    async translateItems() {
        this.oneQuestion = await this._$translate('modules.application.detail.templates.faq.oneQuestion');
        this.multipleQuestions = await this._$translate('modules.application.detail.templates.faq.multipleQuestions');
        this.errorMsg54 = await this._$translate('utils.errorMsg.54');
        this.errorMsg55 = await this._$translate('utils.errorMsg.55');
    }
    async init() {
        //translate
        await this.translateItems();
        this.noMoreFaq = true;
        this._unfilteredItems = [];
        this._faqSets = [];
        //Kill interval
        this._$rootScope.$on('$stateChangeStart', () => {
            if (this.currentWatcher) {
                this.stopChecking();
            }
        });
        //Check current context status every 2 minutes
        await this.getCurrentContext();
        if (this.contextStatus == 1) {
            this.throwInterval();
        }
        Promise.all([
            this._loadIntentions(),
            //this._loadUnknownQuestions()
        ]);
    }
    stopChecking(promise) {
        if (promise) {
            this._$interval.cancel(promise);
        }
        else {
            this._$interval.cancel(this.currentWatcher);
            this.currentWatcher = undefined;
        }
    }
    //Current context can be:
    //1 - training;
    //2 - available;
    //3 - published.
    async getCurrentContext() {
        try {
            const { items } = await this._faqService.getContext(this._application);
            this.contextStatus = parseInt(items[0].status);
            this.classifier = items[0].classifier;
            this.canTrain = items[0].canTrain;
            return this.contextStatus;
        }
        catch (e) {
            const errorMsg51 = await this._$translate('utils.errorMsg.51');
            this._ngToast.danger(errorMsg51);
            throw e;
        }
    }
    //Publish FAQ Bot
    async publish() {
        if (this.contextStatus == 1) {
            const errorMsg52 = await this._$translate('utils.errorMsg.52');
            this._ngToast.danger(errorMsg52);
        }
        else if (this.contextStatus == 2) {
            this._loadingService.startLoading();
            try {
                await this._faqService.publishSet(this._application);
                const successMsg9 = await this._$translate('utils.successMsg.9');
                this._ngToast.success(successMsg9);
                this.contextStatus = 3;
            }
            catch (err) {
                if (err.description.indexOf('Not Authorized') != -1) {
                    const errorMsg53 = await this._$translate('utils.errorMsg.53');
                    this._ngToast.danger(errorMsg53);
                    throw err;
                }
                else {
                    const errorMsg54 = await this._$translate('utils.errorMsg.54');
                    this._ngToast.danger(errorMsg54);
                    throw err;
                }
            }
            finally {
                this._loadingService.stopLoading();
            }
        }
    }
    searchIntentions(txt) {
        this._faqBuffer = this._faqBuffer ? this._faqBuffer : this.faqSets;
        this.faqPerPage = 10;
        this.perPageAux = 0;
        if (txt.length > 2) {
            this._loadIntentions(txt);
        }
        else {
            this.faqSets = this._faqBuffer;
        }
    }
    disableFaq() {
        return this.isLoading || this.noMoreFaq;
    }
    totalQuestions(total) {
        return total > 1
            ? `<span>${total}</span> ${this.multipleQuestions}`
            : `<span>${total}</span> ${this.oneQuestion}`;
    }
    //Function for do infinite scroll
    async loadMore() {
        if (!this.initialLoading) {
            return;
        }
        this.isLoading = true;
        try {
            const text = this.searchFaqTxt && this.searchFaqTxt.length >= 2
                ? encodeURIComponent(this.searchFaqTxt)
                : '';
            const payload = {
                skip: this.perPageAux,
                take: this.faqPerPage,
                text,
            };
            const { items } = await this._faqService.getIntentions(this._application, payload);
            this._unfilteredItems.concat(items);
            if (items.length == 0) {
                this.noMoreFaq = true;
            }
            this._faqSets = this._faqSets.concat(items);
            this.isLoading = false;
            this.perPageAux += this.faqPerPage;
        }
        catch (e) {
            const errorMsg21 = await this._$translate('utils.errorMsg.21');
            this._ngToast.danger(errorMsg21);
            throw e;
        }
    }
    //Load Faq sets (intentions)
    async _loadIntentions(searchFor) {
        const blockScreen = searchFor ? false : true;
        this.initialLoading = true;
        this._loadingService.startLoading();
        try {
            const text = searchFor && searchFor.length >= 2
                ? encodeURIComponent(searchFor)
                : '';
            const payload = {
                skip: this.perPageAux,
                take: this.faqPerPage,
                text,
            };
            const { items } = await this._faqService.getIntentions(this._application, payload);
            this._unfilteredItems = items;
            this._faqSets = items;
            this.perPageAux += this.faqPerPage;
            this.noMoreFaq = false;
        }
        catch (e) {
            const errorMsg21 = await this._$translate('utils.errorMsg.21');
            this._ngToast.danger(errorMsg21);
            throw e;
        }
        finally {
            this._loadingService.stopLoading(blockScreen);
        }
    }
    //Load unknown questions
    async _loadUnknownQuestions() {
        try {
            if (!this.unknownQuestions) {
                const { items } = await this._faqService.getUnknownQuestions(this._application, { skip: 0, take: 50 });
                this.unknownQuestions =
                    items.length >= 1
                        ? `${items.length} ${this.errorMsg55}`
                        : this.errorMsg54;
            }
        }
        catch (e) {
            const errorMsg22 = await this._$translate('utils.errorMsg.22');
            this._ngToast.danger(errorMsg22);
            throw e;
        }
    }
    //Start training
    async startTraining() {
        this._loadingService.startLoading();
        try {
            await this._faqService.trainSet(this._application);
            const successMsg10 = await this._$translate('utils.successMsg.10');
            this._ngToast.success(successMsg10);
            //Training context
            this.contextStatus = 1;
            this.canTrain = false;
            //Reset $interval if exists
            this.currentWatcher = undefined;
            this.throwInterval();
            //Set all intentions as trained
            this._faqSets.map((item) => (item.isTrained = true));
        }
        catch (e) {
            if (e.description.indexOf('Unauthorized') != -1) {
                const errorMsg56 = await this._$translate('utils.errorMsg.56');
                this._ngToast.danger(errorMsg56);
                throw e;
            }
            else {
                const errorMsg23 = await this._$translate('utils.errorMsg.23');
                this._ngToast.danger(errorMsg23);
                throw e;
            }
        }
        finally {
            this._loadingService.stopLoading();
        }
    }
}
// Explicit AngularJS DI annotation for minification safety
FaqController.$inject = ['LoadingService', 'ngToast', 'FaqService', 'application', '$filter', '$timeout', '$interval', '$rootScope', '$scope', '$translate'];
